"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var table_1 = require("antd/lib/table");
var FontAwesome_1 = require("../../../../../../../../shared/components/icons/FontAwesome");
var WrapTableActions_1 = require("../../../../../../../../shared/components/table_actions/WrapTableActions");
var TableActionDelete_1 = require("../../../../../../../../shared/components/table_actions/TableActionDelete");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var TableActionEdit_1 = require("../../../../../../../../shared/components/table_actions/TableActionEdit");
var TableActionStats_1 = require("../../../../../../../../shared/components/table_actions/TableActionStats");
var BonusTournamentSessionsList = /** @class */ (function (_super) {
    __extends(BonusTournamentSessionsList, _super);
    function BonusTournamentSessionsList(props) {
        return _super.call(this, props) || this;
    }
    BonusTournamentSessionsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            totalRows: 0,
        }, function () {
            _this.props.data.LoadData(_this.props.rootRecord.key);
            _this.props.state.setExtBreadCrumbPath(["Сессии турнира"]);
        });
    };
    BonusTournamentSessionsList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    BonusTournamentSessionsList.prototype.getColumns = function () {
        var _this = this;
        return ([{
                title: 'Турнир',
                dataIndex: this.props.data.dk_key,
                key: this.props.data.dk_key,
                width: 150,
                render: function (text, record, idx) {
                    return React.createElement("div", null,
                        React.createElement(FontAwesome_1.FA, { right: true, icon: "registered" }),
                        " ",
                        _this.props.rootRecord.title);
                }
            }, {
                title: 'Логин',
                dataIndex: this.props.data.dk_usr_player_login,
                key: this.props.data.dk_usr_player_login,
                width: 150
            }, {
                title: 'Бот',
                dataIndex: this.props.data.dk_freespin_count_played,
                key: this.props.data.dk_freespin_count_played,
                render: function (text, record, idx) {
                    if (record.is_bot_session) {
                        return React.createElement("div", null, "\u0414\u0410");
                    }
                    else {
                        return React.createElement("div", null, "\u041D\u0415\u0422");
                    }
                },
                width: 150
            }, {
                title: 'Сыграно/Доступно',
                dataIndex: this.props.data.dk_freespin_count_played,
                key: this.props.data.dk_freespin_count_played,
                render: function (text, record, idx) {
                    return React.createElement("div", null,
                        record.freespin_count_played,
                        " : ",
                        record.freespin_count_avail);
                },
                width: 150
            }, {
                title: 'Куплено/Лимит',
                dataIndex: this.props.data.dk_tickets_available,
                key: this.props.data.dk_tickets_available,
                render: function (text, record, idx) {
                    if (record.is_unlimited_tickets_buys) {
                        return React.createElement("div", null,
                            record.tickets_buyed,
                            " : \u041D\u0435\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u043E");
                    }
                    else {
                        return React.createElement("div", null,
                            record.tickets_buyed,
                            " : ",
                            record.tickets_available);
                    }
                },
                width: 150
            }, {
                title: 'Баланс',
                dataIndex: this.props.data.dk_freespin_win_amount,
                key: this.props.data.dk_freespin_win_amount,
                width: 150
            }, {
                title: 'Добавлена',
                dataIndex: this.props.data.dk_date_added2,
                key: this.props.data.dk_date_added2,
                width: 150,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added2.format(_this.props.state.getDateTimeFormat())));
                }
            }, {
                title: 'Изменена',
                dataIndex: this.props.data.dk_date_changed2,
                key: this.props.data.dk_date_changed2,
                width: 150,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_changed2.format(_this.props.state.getDateTimeFormat())));
                }
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionStats_1.default, { hint: "\u041B\u043E\u0433\u0438 \u0438\u0433\u0440", onClick: function () { _this.onViewLogClick(record); } }),
                    React.createElement(TableActionStats_1.default, { hint: "\u041B\u043E\u0433\u0438 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439", onClick: function () { _this.onViewActionClick(record); } }),
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditPlayerClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeletePlayerClick(record); } }))); },
                width: 100
            }
        ]);
    };
    BonusTournamentSessionsList.prototype.onViewLogClick = function (record) {
        if (this.props.onViewLogsClick) {
            this.props.onViewLogsClick(record);
        }
    };
    BonusTournamentSessionsList.prototype.onViewActionClick = function (record) {
        if (this.props.onViewActionsClick) {
            this.props.onViewActionsClick(record);
        }
    };
    BonusTournamentSessionsList.prototype.onDeletePlayerClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u0417\u0430\u043F\u0438\u0441\u044C \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u0430"));
        });
    };
    BonusTournamentSessionsList.prototype.onEditPlayerClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    BonusTournamentSessionsList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData(this.props.rootRecord.key);
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
        if (action === "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
    };
    BonusTournamentSessionsList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить", back: "Назад" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(table_1.default, { bordered: true, columns: this.getColumns(), dataSource: this.state.data, locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, pagination: {
                    pageSize: this.props.state.UITablePageSize,
                    showSizeChanger: true,
                    total: this.state.totalRows,
                    position: "bottom",
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) { return React.createElement("div", { style: { margin: 0 } },
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                        " [",
                        record.date_added2.format(_this.props.state.getDateTimeFormat()),
                        "] "),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                        " [",
                        record.date_changed2.format(_this.props.state.getDateTimeFormat()),
                        "]")); } })));
    };
    return BonusTournamentSessionsList;
}(React.Component));
exports.default = BonusTournamentSessionsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_tournament/ui/component/options/sessions/BonusTournamentSessionsList.tsx
// module id = 2527
// module chunks = 0